import { Icon as a } from "../../../components/Icon/index.js";
import { Dropdown as t } from "../../Dropdown/index.js";
import { styled as o } from "styled-components";
import { Colors as i } from "../../../styles/colors/index.js";
import { Theme as r } from "../../../styles/themes/index.js";
import { CaptionLight as n, SmallHeavy as s } from "../../../styles/typography/index.js";
import { MediaQuery as e } from "../../../styles/variables.js";
import { dropdownListMobileFullPageStyle as d } from "../../Dropdown/components/DropdownList/style.js";
import "react/jsx-runtime";
import "react";
import "react-dom";
const h = o(a)`
  font-size: 24px;
  color: rgb(${r.colors.BravoBravo});

  &[aria-disabled='true'] {
    color: rgb(${i.Gray});
  }
`, S = o(a)`
  font-size: 24px;
  color: rgb(${r.colors.Brand});

  &[aria-disabled='true'] {
    color: rgb(${i.Gray});
  }
`, C = o(t.Item)`
  && {
    ${n}
    white-space: nowrap;
  }
`, w = o.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 134px;
  border-radius: 24px;
  transition: all 0.5s ease;
  box-sizing: border-box;
  border: 1px solid rgb(${r.colors.Golf});

  &:hover:not(:disabled) {
    background-color: rgb(${r.colors.Kilo});
  }

  &[aria-disabled='true'] {
    color: rgb(${i.Gray});
  }
`, v = o.button`
  background: transparent;
  display: flex;
  pointer-events: all;

  @media ${e.SCREEN_MD_UP} {
    display: none;
  }
`, E = o(t.Root)`
  display: none;

  @media ${e.SCREEN_MD_UP} {
    display: flex;
  }
`, M = o(t.List)`
  && {
    padding: 0;
    border-radius: 8px;
    width: 148px;
  }
  @media ${e.SCREEN_SM} {
    ${d};
  }
`, B = o.div`
  ${s}
  margin: 0 4px;
`;
export {
  w as Container,
  S as CopyIcon,
  M as CustomDropdownList,
  E as CustomDropdownRoot,
  C as ShareButtonListItem,
  v as ShareButtonMobile,
  h as ShareIcon,
  B as ShareText
};
